import { isPlatformBrowser } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { mobileErrorMessage, mobileHyphensComplete, mobileHyphensSetInstead, validateNumber } from 'src/app/core/helpers/app-link'
import { addFocusOutEventSetInvalid, clickoutCloseInput,
  removeInvalidOn, setInvalidOn, setMobileAfterChangeAllHyphens,
  transformLoanAmountWithCommas } from 'src/app/core/helpers/fields-utils'
import { inputAriaCheckActiveState, numberWithCommas } from 'src/app/core/helpers/inputs-helper'
import { ModalTypes } from 'src/app/core/helpers/modal-store'
import { LoanOptionsService } from 'src/app/core/services/loan-options.service'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { PageNavigationService } from 'src/app/core/services/page-navigation.service'
import { mobileSetValueInputArea, scrollModalToTop } from '../options-utils/modal-shared'

@Component({
    selector: 'app-modal-options-offer',
    templateUrl: './modal-options-offer.component.html',
    styleUrls: ['./modal-options-offer.component.scss'],
    standalone: false
})
export class ModalOptionsOfferComponent implements OnInit{
  @Input() loanAmount = '2,500'
  @Input() breakpoints: any = [{}]
  @Input() loanAcctId: any = null
  @Input() mobileNumber = ''
  @Input() offerInfo: any = {}
  @Output() sendAppLinkEvent: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()

  isPopup = false

  transformLoanAmountWithCommas = transformLoanAmountWithCommas



  constructor(
    public loanOptionsService: LoanOptionsService,
    public pageNavigationService: PageNavigationService,
    public modalStateService: ModalStateService,
    public logger: NGXLogger,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) { }



  ngOnInit() {
       if (!isPlatformBrowser(this.platformId)) {
    return;
  }
    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
    // client code
    if (isPlatformBrowser(this.platformId)) {
      scrollModalToTop()
      setTimeout(() => {
        setMobileAfterChangeAllHyphens('appLinkInputModal')
        if (this.modalStateService.getFromLocalStorage('ext_offerInfo')) {
          this.restoreOfferData()
        }
        mobileSetValueInputArea('appLinkInputModalDiv', 'appLinkInputModal', this.mobileNumber)
        // addFocusOutEventSetInvalid('appLinkInputModal', 'appLinkInputModalDiv', validateNumber)
        if (this.mobileNumber) {
          (document.getElementById('appLinkInputModal') as any).disabled = true
        }
      }, 500)

    }
  }

  onMobileInput(e) {
    mobileHyphensComplete(e, e.target)
  }

  showPopup() {
    this.isPopup = true
  }

  onPopupClosed() {
    this.isPopup = false
  }


  inputItemClick(event: any): void
  {
    inputAriaCheckActiveState(event.currentTarget)
  }



  @HostListener('document:click', ['$event'])
  clickout(event) {
    clickoutCloseInput(event)
  }

  saveState() {
    this.logger.info('saving state!!')
    this.modalStateService.pushToLocalStorage('externalLink', 'true')
    this.logger.info('this.layout')
    this.modalStateService.pushToLocalStorage('modalType', ModalTypes.offer)
    this.saveOfferData()
  }

  restoreOfferData() {
    const extObj = this.modalStateService.getFromLocalStorageProps({
      ext_offerInfo: null,
      ext_loanAmount: null,
      ext_service: null,
      ext_mobile: null
    })

    this.offerInfo = extObj.ext_offerInfo
    this.loanAmount = extObj.ext_offerInfo.autoPay?.approvedAmount || extObj.ext_offerInfo.noAutoPay?.approvedAmount || extObj.ext_loanAmount
    this.mobileNumber = extObj.ext_mobile
    this.loanOptionsService.loanAcctId = extObj.ext_service.currentLoanAcctId
    this.loanOptionsService.coappLoanAcctId = extObj.ext_service.currentCoappLoanAcctId
    this.loanOptionsService.coappMobileNumber = extObj.ext_service.coappMobile


    this.modalStateService.pushToLocalStorageProps({
      ext_offerInfo: null,
      ext_loanAmount: null,
      ext_service: null,
      ext_mobile: null
    })
  }

  saveOfferData() {
    const service = {
      currentLoanAcctId: this.loanOptionsService.loanAcctId,
      currentCoappLoanAcctId: this.loanOptionsService.coappLoanAcctId,
      coappMobile: this.loanOptionsService.coappMobileNumber,
    }
    this.modalStateService.pushToLocalStorageProps({
      ext_offerInfo: this.offerInfo,
      ext_loanAmount: this.loanAmount,
      ext_service: service,
      ext_mobile: this.mobileNumber
    })
  }


  toSendAppLinkEvent(event) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    // fetch data
    const service = {
      currentLoanAcctId: this.loanOptionsService.loanAcctId,
      currentCoappLoanAcctId: this.loanOptionsService.coappLoanAcctId,
      coappMobile: this.loanOptionsService.coappMobileNumber,
    }
    const userMobile = (document.getElementById('appLinkInputModal') as any).value
    const targetDivId = 'appLinkInputModalDiv'
    if (!userMobile || !validateNumber(userMobile)) {
      setInvalidOn(targetDivId)
      // this.notifier.notify('error', mobileErrorMessage)
      return
    }
    removeInvalidOn(targetDivId)
    this.logger.info(service)

    this.sendAppLinkEvent.emit({
      email: '', phone: userMobile,
      loanAcctId: service.currentLoanAcctId || '',
      cobo: !!service.coappMobile // true/false
    })
    this.cdr.detectChanges()
  }

}
